<template>
  <Layout v-loading="pageLoading">
    <title-repeat-check ref="titleCheck"></title-repeat-check>
    <div class="row box_wrap" style="height: calc(100vh - 175px)">
      <div class="col-lg-12">
        <div class="">
          <div class="card-body">
            <el-tabs v-model="activeName">
              <el-tab-pane label="基础信息" name="base">
                <div class="card-body-form" style="overflow: hidden">
                  <div v-if="allModify" class="page-transparent-bg"></div>
                  <!-- 不可编辑区域 -->
                  <div class="app-disabled-main">
                    <div v-if="isModify" class="disabled-main-bg"></div>

                    <div class="row">
                      <div class="col-md-7">
                        <div class="mb-3">
                          <label>标题</label>
                          <div class="title-limit-desc">
                            <input
                              v-model="item.title"
                              type="text"
                              class="form-control"
                              maxlength="200"
                              placeholder="请输入1-200个字"
                              @blur="checkTitle(item.title)"
                            />
                            <span class="number-of-word"
                              >{{ item.title.length }}/200</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-7">
                        <div class="mb-3">
                          <label>短标题</label>
                          <div class="title-limit-desc">
                            <input
                              v-model="item.subTitle"
                              type="text"
                              class="form-control"
                              maxlength="200"
                              placeholder="请输入1-200个字"
                            />
                            <span class="number-of-word"
                              >{{ item.subTitle.length }}/200</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-7">
                        <div class="mb-3">
                          <label>来源</label>
                          <input
                            v-model="item.source"
                            type="text"
                            class="form-control"
                            placeholder="文章出处，列如：新华社"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="mb-3">
                        <label>发布日期</label> <br />

                        <!-- <date-picker
                      v-model="item.publishedAt"
                      placeholder="输入日期"
                      type="datetime"
                      value-type='format'
                      :disabled-date="disabledDate"
                      format="YYYY-MM-DD HH:mm:ss"
                      :minute-step=1
                      :editable="false"
                      confirm></date-picker> -->
                        <el-date-picker
                          v-model="item.publishedAt"
                          type="datetime"
                          placeholder="选择日期时间"
                          align="right"
                          value-format="yyyy-MM-dd HH:mm:ss"
                        >
                        </el-date-picker>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-3">
                      <div class="mb-3">
                        <label>角标</label>
                        <input
                          v-model="item.subscript"
                          maxlength="4"
                          type="text"
                          class="form-control"
                          placeholder="请输入1-4个字"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label>设置</label>
                        <div class="dsply-fix flex-align-center">
                          <b-form-checkbox
                            class="m-r-30"
                            v-for="item in operable"
                            :key="item.key"
                            v-model="choiceOperable"
                            :value="item.key"
                            checked
                            plain
                            >{{ item.text }}</b-form-checkbox
                          >
                          <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            @click="getAudio"
                            v-if="
                              index_id !== undefined &&
                                audioUrl == '' &&
                                audioUrl != 'audio'
                            "
                            :disabled="index_id === undefined"
                          >
                            生成音频
                          </button>
                          <span v-if="audioUrl !== '' && audioUrl === 'audio'">
                            <t-loading /><span style="margin-left: 10px"
                              >远端生成音频中</span
                            ></span
                          >
                          <audio
                            controls
                            v-if="audioUrl != '' && audioUrl != 'audio'"
                          >
                            <source :src="audioUrl" />
                          </audio>
                          <!-- <audio controls>
                        <source
                          src="https://hsp-dev-1258156964.cos.ap-guangzhou.myqcloud.com/saas/video/tts/2022-08/f6ccd128-be1d-4414-b09b-682519abf6cb.mp3"
                        />
                      </audio> -->
                          <button
                            v-if="audioUrl != '' && audioUrl != 'audio'"
                            style="margin-left: 10px"
                            type="button"
                            class="btn btn-sm btn-danger"
                            @click="deleteAudio"
                          >
                            删除
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label>评论限制</label>
                        <div class="dsply-fix">
                          <b-form-checkbox
                            class="m-r-30"
                            v-for="item in commentRests"
                            :key="item.key"
                            v-model="choiceCommentRests"
                            :value="item.key"
                            checked
                            plain
                            >{{ item.text }}</b-form-checkbox
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label>标签</label>
                        <div
                          class="select-tabs flex"
                          style="align-items: center; flex-wrap: wrap"
                        >
                          <div
                            v-for="item in currentTabs"
                            :key="item.id"
                            role="alert"
                            aria-live="polite"
                            aria-atomic="true"
                            class="pull-left alert alert-primary m-r-20"
                          >
                            {{ item.name }}
                            <span @click="removeTabs(item)">
                              <i class="bx bx-x font-size-16 align-middle"></i>
                            </span>
                          </div>

                          <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            @click="selectTag()"
                          >
                            <i
                              class="bx bx-plus font-size-16 align-middle me-2"
                            ></i>
                            添加
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label>运营</label>
                        <div class="dsply-fix">
                          <!-- <b-form-checkbox
                        class="m-r-30"
                        v-for="item in operateSet"
                        :key="item.key"
                        v-model="choiceOperateSet"
                        :value="item.key"
                        checked
                        plain
                        >{{ item.text }}</b-form-checkbox
                      > -->
                          <div class="operate-input-item">
                            <span class="pull-left">阅读数</span>
                            <input
                              v-model="item.operateViewNum"
                              type="text"
                              class="form-control"
                              placeholder="数字"
                            />
                          </div>
                          <div class="operate-input-item">
                            <span class="pull-left">点赞数</span>
                            <input
                              v-model="item.operateLikeNum"
                              type="text"
                              class="form-control"
                              placeholder="数字"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-7">
                      <div class="mb-3">
                        <label>分享标题</label>
                        <div class="title-limit-desc">
                          <input
                            v-model="item.shareTitle"
                            type="text"
                            class="form-control"
                            maxlength="200"
                            placeholder="请输入1-200个字"
                          />
                          <span class="number-of-word"
                            >{{ item.shareTitle.length }}/200</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label>分享图片</label>
                        <div class="mb-3">
                          <upload-button
                            type="image"
                            @onSuccess="shareImageSuccess"
                            :mustEdit="true"
                          ></upload-button>
                        </div>
                        <div
                          class="cover-images clearfix"
                          style="margin-top: 10px; margin-bottom: 10px"
                        >
                          <div class="cover-img-item m-r-40" v-if="shareImage">
                            <div class="cover-image-main">
                              <image-upload
                                :fixedWidth="150"
                                size="1:1"
                                v-model="shareImage.url"
                                @uploadChange="changeShareImage"
                                type="image"
                                :isShowDel="false"
                              ></image-upload>
                            </div>
                            <span
                              class="cover-delete"
                              @click="removeShareImage()"
                              >删除</span
                            >
                          </div>
                        </div>
                        <div style="color: #aaa">
                          图片比例 1:1，建议尺寸 670 * 670
                          px，不上传则默认使用封面图片
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="row">
                    <div class="col-md-10">
                      <div class="mb-3">
                        <label>评论</label>
                        <div class="mb-3">
                          <button
                            type="button"
                            class="btn btn-sm btn-primary m-r-20"
                            @click="selectComment(item)"
                          >
                            <i
                              class="bx bx-plus font-size-16 align-middle me-2"
                            ></i>
                            添加
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            @click="removeComment()"
                            v-if="currentComments.length"
                          >
                            <i
                              class="bx bx-trash font-size-16 align-middle me-2"
                            ></i>
                            移除
                          </button>
                        </div>
                        <div
                          class="table-responsive-main-list"
                          v-if="currentComments.length"
                        >
                          <div class="table-responsive">
                            <table
                              class="table align-middle table-nowrap table-hover"
                            >
                              <thead class="table-light">
                                <tr>
                                  <th scope="col" style="width: 70px;"></th>
                                  <th scope="col" style="width: 70px;">ID</th>
                                  <th scope="col">评论内容</th>
                                  <th scope="col">评论附件</th>
                                  <th scope="col">评论来源</th>
                                  <th scope="col">来源标题</th>
                                  <th scope="col">来源链接</th>
                                  <th scope="col">点赞数</th>
                                  <th scope="col">标签</th>
                                  <th scope="col">采集时间</th>
                                  <th scope="col">发布时间</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="data in currentComments"
                                  :key="data.id"
                                >
                                  <td>
                                    <b-form-checkbox
                                      v-model="selectCurrentItems"
                                      :value="data"
                                      checked
                                      plain
                                    ></b-form-checkbox>
                                  </td>
                                  <td>{{ data.id }}</td>
                                  <td class="white-inherit">
                                    {{ data.message }}
                                  </td>
                                  <td>
                                    <img
                                      v-if="data.image"
                                      class="w-3-rem"
                                      :src="`${data.image}`"
                                      alt
                                    />
                                    <img
                                      v-if="!data.image"
                                      class="w-3-rem"
                                      src="@/assets/images/image-null.jpg"
                                      alt=""
                                    />
                                  </td>
                                  <td>{{ data.source }}</td>
                                  <td>{{ data.title }}</td>
                                  <td>{{ data.link }}</td>
                                  <td>{{ data.likeNum || "--" }}</td>
                                  <td>{{ data.tag || "--" }}</td>
                                  <td>{{ data.collectedAt || "--" }}</td>
                                  <td>{{ data.publishedAt || "--" }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <!-- 不可编辑区域 -->
                  <div class="app-disabled-main">
                    <div v-if="isModify" class="disabled-main-bg"></div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="mb-3">
                          <label>封面图片</label>
                          <div class="mb-3">
                            <!-- <div class="pull-left">
                          <button
                            @click="getCovers()"
                            type="button"
                            class="btn btn-primary m-r-20"
                            :disabled="isModify"
                          >
                            <i
                              class="bx bx-cloud-download font-size-16 align-middle me-2"
                            ></i>
                            获取智能封面
                          </button>
                        </div> -->
                            <upload-button
                              type="image"
                              :disabled="isModify"
                              @onSuccess="uploadSuccess"
                              :mustEdit="true"
                            ></upload-button>
                          </div>

                          <div
                            class="cover-images clearfix"
                            style="margin-bottom: 10px"
                          >
                            <div
                              class="cover-img-item m-r-40"
                              v-for="(url, index) in coverImags"
                              v-bind:key="index"
                            >
                              <div class="cover-image-main">
                                <!-- <img
                              :style="sliderStyle"
                              @click="viewImage(url)"
                              :src="url"
                              alt=""
                            /> -->
                                <image-upload
                                  :fixedWidth="200"
                                  size="16:9"
                                  v-model="coverImags[index]"
                                  :disabled="isModify"
                                  @uploadChange="changeCover"
                                ></image-upload>
                                <i
                                  v-if="item.image != url"
                                  @click="item.image = url"
                                  class="bx bx-circle"
                                ></i>
                                <i
                                  v-if="item.image == url"
                                  class="bx bx-check-circle"
                                ></i>
                              </div>
                              <span
                                class="cover-delete"
                                @click="removeCover(index)"
                                >删除</span
                              >
                            </div>
                          </div>
                          <div style="color: #aaa">
                            图片比例 4:3，建议尺寸 670 * 500 px，建议文件小于1M
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="row">
                      <div class="col-md-12">
                        <div class="mb-3">
                          <label>附件</label>
                          <div class="col-md-7">
                            <upload-attatch
                              ref="attachment"
                              :urls="item.attachments"
                              :disabled="isModify"
                            ></upload-attatch>
                          </div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="文章详情" name="editor">
                <div class="card-body-form" style="overflow: hidden">
                  <div class="app-disabled-main">
                    <div v-if="isModify" class="disabled-main-bg"></div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="">
                          <div>
                            <editor
                              ref="editor"
                              :disabled="isModify"
                              v-model="item.content"
                              @cover="setArticleCover"
                              @shareCover="setArticleShareCover"
                              :canSetCover="true"
                              fromFunction="article"
                            ></editor>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>

            <!-- <div class="row submit-bar"> -->
            <!-- <div class="col-md-12">
                <div class="bar-handle" v-if="!allModify">
                  <button
                    class="btn-sm btn btn-outline-dark"
                    type="button"
                    @click="goBack()"
                  >
                    取消
                  </button>
                  <div v-if="!isModify">
                    <button
                      @click="submitReview()"
                      v-if="index_id && item.verifyState != 3"
                      class="btn-sm btn btn-warning"
                      type="button"
                    >
                      保存并提交审核
                    </button>
                    <button
                      @click="revokeReview()"
                      v-if="index_id && item.verifyState == 3"
                      class="btn-sm btn btn-warning"
                      type="button"
                    >
                      撤销审核
                    </button>
                  </div>

                  <button
                    v-if="index_id"
                    @click="submitPreserve()"
                    class="btn-sm btn btn-primary"
                    type="button"
                  >
                    保存
                  </button>

                  <button
                    @click="submitReview()"
                    v-if="!index_id"
                    class="btn-sm btn btn-warning"
                    type="button"
                  >
                    创建并提交审核
                  </button>
                  <button
                    v-if="!index_id"
                    @click="submitPreserve()"
                    class="btn-sm btn btn-primary"
                    type="button"
                  >
                    创建
                  </button>

                </div>
                <div class="bar-handle" v-if="allModify">
                  <button
                    class="btn-sm btn btn-outline-dark"
                    type="button"
                    @click="goBack()"
                  >
                    返回
                  </button>
                </div>
              </div> -->
            <!-- </div> -->
            <!-- <button
              @click="openLog"
              v-if="isModify"
              class="btn-sm btn btn-warning"
              type="button"
            >
              操作日志
            </button> -->
          </div>
        </div>
      </div>
      <!-- 操作日志 -->
      <operationLog :show.sync="show" :resId="resId"></operationLog>
      <media-dialog @pageCallback="pageCallback" ref="media"></media-dialog>
      <tag-dialog @pageCallback="pageCallback" ref="tag"></tag-dialog>
      <!-- <comment-dialog
        @pageCallback="pageCallback"
        ref="comment"
      ></comment-dialog> -->
    </div>
    <!-- <div style="height: 6px; border-bottom: 1px solid #ced4da"></div> -->
    <div
      class="row submit-bar"
      style="
        margin-bottom: 0;
        margin-top: 0;
        padding-top: 0;
        padding-bottom: 0;
        height: 45px;
        display: flex;
        align-items: center;
      "
    >
      <div class="col-md-12">
        <div class="last-time pull-left" style="margin-right: 1rem">
          <button
            style="margin-left: 20px"
            @click="openLog"
            class="btn-sm btn btn-warning"
            type="button"
          >
            操作日志
          </button>
        </div>
        <div v-if="!isModify" class="last-time pull-left">
          <button
            @click="resetData"
            class="btn-sm btn btn-outline-dark"
            type="button"
          >
            <i class="el-icon-refresh"></i>
            重置修改
          </button>
        </div>
        <div class="bar-handle" v-if="!allModify">
          <button
            class="btn-sm btn btn-outline-dark"
            type="button"
            @click="goBack()"
          >
            返回
          </button>
          <span>
            <button
              v-if="index_id"
              @click="toPreview()"
              class="btn-sm btn btn-primary"
              type="button"
            >
              预览
            </button>
          </span>
          <div v-if="!isModify">
            <button
              @click="submitReview()"
              v-if="
                index_id &&
                  item.verifyState != 3 &&
                  power['提交审核/撤销审核/驳回原因']
              "
              class="btn-sm btn btn-warning"
              type="button"
            >
              {{ verifyFlag == 1 ? "保存并免审发布" : "保存并提交审核" }}
            </button>
            <button
              @click="revokeReview()"
              v-if="
                index_id &&
                  item.verifyState == 3 &&
                  power['提交审核/撤销审核/驳回原因']
              "
              class="btn-sm btn btn-warning"
              type="button"
            >
              撤销审核
            </button>
          </div>

          <button
            v-if="index_id"
            @click="submitPreserve()"
            class="btn-sm btn btn-primary"
            type="button"
          >
            保存
          </button>

          <button
            @click="submitReview()"
            v-if="!index_id && power['提交审核/撤销审核/驳回原因']"
            class="btn-sm btn btn-warning"
            type="button"
          >
            {{ verifyFlag == 1 ? "创建并免审发布" : "创建并提交审核" }}
          </button>
          <button
            v-if="!index_id"
            @click="submitPreserve()"
            class="btn-sm btn btn-primary"
            type="button"
          >
            创建
          </button>

          <!-- <button @click="submitPublish()" v-if="isModify" class="btn-sm btn btn-primary" type="button">发布</button> -->
        </div>
        <div class="bar-handle" v-if="allModify">
          <button
            class="btn-sm btn btn-outline-dark"
            type="button"
            @click="goBack()"
          >
            返回
          </button>
        </div>
      </div>
      <el-drawer
        :visible.sync="drawer"
        size="450px"
        :direction="direction"
        :show-close="false"
      >
        <iframe ref="iframe" class="iframe-item" :src="previewUrl"></iframe>
      </el-drawer>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "@/router/layouts/main";
import imageUpload from "@/components/imageUpload";
import editor from "@/components/editor/Editor";
import DatePicker from "vue2-datepicker";
import { userGridData } from "./data-user";
import mediaDialog from "./mediaDialog";
import tagDialog from "@/components/choseTag/tagDialog.vue";
// import commentDialog from "./commentDialog";
import subjectDialog from "./subjectDialog";
import article from "@/server/api/article";
import account from "@/server/api/account";
import tags from "@/server/api/tags";
import auth from "@/server/api/auth";
import operationLog from "@/components/operationLog.vue";
import $_channel from "../../../server/api/channel/channel.api";
import contentAPI from "@/server/api/content.js";
// import UploadAttatch from "./attachment/UploadAttatch.vue";
import { getOperateNum, checkRepeatTitle, waitTime } from "@/util/fun.js";
import TitleRepeatCheck from "@/components/TitleRepeatCheck.vue";
export default {
  components: {
    Layout,
    DatePicker,
    imageUpload,
    editor,
    mediaDialog,
    tagDialog,
    // commentDialog,
    operationLog,
    // UploadAttatch,
    TitleRepeatCheck,
  },
  inject: ["reload"],
  data() {
    return {
      activeName: "base",
      audioUrl: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },

      operable: [
        { text: "关闭阅读数", key: "viewDisabled" },
        { text: "关闭评论", key: "commentDisabled" },
        { text: "关闭分享", key: "shareDisabled" },
        { text: "关闭点赞", key: "likeDisabled" },
      ],
      choiceOperable: [], //设置选择了那些
      commentRests: [
        { text: "关闭图片评论", key: "commentImageDisabled" },
        { text: "关闭视频评论", key: "commentVideoDisabled" },
      ],
      choiceCommentRests: [], //评论设置选择了那些
      operateSet: [
        { text: "加入推荐池", key: "addIndex" },
        { text: "加入榜单管理", key: "addRecommend" },
        // { text: '是否上本地首页', key: 'addLocal' }
      ],
      choiceOperateSet: [], //运营设置选择了那些
      dataUser: userGridData,
      item: {
        publishedAt: "",
        image: "",
        content: "",
        title: "",
        subTitle: "",
        channelIds: [],
        shareTitle: "",
      },
      disabledDate: null,
      currentMedia: {},
      currentTabs: [],
      // currentComments: [],
      selectCurrentItems: [],
      coverImags: [],
      index_id: undefined,
      isModify: false,
      allModify: false,
      sliderStyle: {},
      syslog: {},
      show: false,
      resId: undefined,
      channelList: [],
      verifyFlag: 0,
      previewUrl: "",
      drawer: false,
      direction: "rtl",
      autoSaveTimer: null,
      shareImage: null,
      oldImage: null, //初始化页面最初封面图片
      oldImageWidth: 0, //初始化页面最初封面图片宽
      oldImageHeight: 0, //初始化页面最初封面图片高
      power: [],
      pageLoading: false,
    };
  },

  created() {
    this.power = this.utils.currentPower("创作平台-文章发布");
    this.item.publishedAt = this.utils.getTodayTime();
    //新建的时候
    if (!this.$route.query.id && !this.isModify && !this.allModify) {
      let autoSaveItem = JSON.parse(this.$storage.get("autoSaveItem") || null);
      console.log(autoSaveItem);
      const user = JSON.parse(this.cookies.getCookie("user"));
      if (autoSaveItem && autoSaveItem.localUserId != user.id) {
        console.log("用户不一致");
        return;
      }
      if (autoSaveItem && !autoSaveItem.id) {
        this.item = autoSaveItem;
        this.item.shareTitle = "";

        // if (this.item.image) {
        //   this.coverImags.push(this.item.image);
        // }

        // this.item.viewDisabled = parseInt(this.item.viewDisabled);
        // this.item.commentDisabled = parseInt(this.item.commentDisabled);
        // this.item.shareDisabled = parseInt(this.item.shareDisabled);
        // this.item.likeDisabled = parseInt(this.item.likeDisabled);
        // this.item.commentImageDisabled = parseInt(
        //   this.item.commentImageDisabled
        // );
        // this.item.commentVideoDisabled = parseInt(
        //   this.item.commentVideoDisabled
        // );
        // //设置选择了那些
        // if (this.item.viewDisabled) {
        //   this.choiceOperable.push("viewDisabled");
        // }
        // if (this.item.commentDisabled) {
        //   this.choiceOperable.push("commentDisabled");
        // }
        // if (this.item.shareDisabled) {
        //   this.choiceOperable.push("shareDisabled");
        // }
        // if (this.item.likeDisabled) {
        //   this.choiceOperable.push("likeDisabled");
        // }

        // //评论设置选择了那些
        // if (this.item.commentImageDisabled) {
        //   this.choiceCommentRests.push("commentImageDisabled");
        // }
        // if (this.item.commentVideoDisabled) {
        //   this.choiceCommentRests.push("commentVideoDisabled");
        // }
        // //标签复现
        // this.currentTabs = this.item.currentTabs;
      } else {
      }
    }
  },

  mounted() {
    let data = JSON.parse(localStorage.chosedMedia);
    this.item.userId = data.id;
    this.verifyFlag = data.verifyFlag;
    // 获取详情
    if (this.$route.query.id) {
      this.index_id = this.$route.query.id;
      this.checkLock();
      this.fetch();
      this.getSyslog();
    } else {
      if (this.item.title) {
        this.$refs.titleCheck.checkTitle(this.item.title);
      }
    }
    if (this.$route.query.isModify) {
      this.isModify = true;
    }
    if (this.$route.query.allModify) {
      this.allModify = true;
    }
    this.disabledDate = this.utils.rangeDate();
    this.getChannelList();

    // 封面图比例
    let size = "4:3";
    let wh = size.split(":");
    let fixedHeight = 150; //固定高度200px
    let fixedWidth = Math.ceil((wh[0] / wh[1]) * fixedHeight);
    this.sliderStyle = {
      width: fixedWidth + "px",
      height: fixedHeight + "px",
    };
    //新建 编辑详情才开启自动保存
    if (!this.isModify && !this.allModify) {
      // console.log("保存的参数", this.saveCreateData);
      this.autoSaveTimer = setInterval(this.saveCreateData, 60000);
    }
  },
  beforeDestroy() {
    clearInterval(this.autoSaveTimer);
    this.autoSaveTimer = null;
  },
  methods: {
    changeShareImage(url) {
      this.shareImage.url = url;
    },
    removeShareImage() {
      this.shareImage = null;
    },
    shareImageSuccess(file) {
      if (file.data) {
        this.shareImage = {
          url: file.data,
          type: file.type,
        };
      }
    },
    resetData() {
      if (this.coverImags[0]) {
        this.coverImags.splice(0, 1);
      }
      this.item = this.$options.data.call(this).item;
      this.currentMedia = this.$options.data.call(this).currentMedia;
      this.currentTabs = this.$options.data.call(this).currentTabs;
      this.choiceOperable = this.$options.data.call(this).choiceOperable;
      this.choiceCommentRests = this.$options.data.call(
        this
      ).choiceCommentRests;
      this.choiceOperateSet = this.$options.data.call(this).choiceOperateSet;
      if (!this.index_id) {
        this.item.publishedAt = this.utils.getTodayTime();
        this.$storage.remove("autoSaveItem");
      } else {
        this.$storage.remove("autoSaveItem");
        this.fetch();
      }
    },
    removeAutoSave() {
      const autoSaveItem = JSON.parse(
        this.$storage.get("autoSaveItem") || null
      );
      if (autoSaveItem) {
        if (this.autoSaveId == this.detailId) {
          this.$storage.remove("autoSaveItem");
        }
      }
    },
    saveCreateData() {
      // //处理标签
      // this.item.currentTabs = this.currentTabs;
      // this.item.viewDisabled = "0";
      // this.item.commentDisabled = "0";
      // this.item.shareDisabled = "0";
      // this.item.likeDisabled = "0";
      // //设置
      // for (var i = 0; i < this.choiceOperable.length; i++) {
      //   let key = this.choiceOperable[i];
      //   if (key == "viewDisabled") {
      //     this.item.viewDisabled = "1";
      //   }
      //   if (key == "commentDisabled") {
      //     this.item.commentDisabled = "1";
      //   }
      //   if (key == "shareDisabled") {
      //     this.item.shareDisabled = "1";
      //   }
      //   if (key == "likeDisabled") {
      //     this.item.likeDisabled = "1";
      //   }
      // }
      // //评论设置
      // this.item.commentImageDisabled = "0";
      // this.item.commentVideoDisabled = "0";
      // for (var i = 0; i < this.choiceCommentRests.length; i++) {
      //   let key = this.choiceCommentRests[i];
      //   if (key == "commentImageDisabled") {
      //     this.item.commentImageDisabled = "1";
      //   }
      //   if (key == "commentVideoDisabled") {
      //     this.item.commentVideoDisabled = "1";
      //   }
      // }
      let item = {
        title: this.item.title,
        subTitle: this.item.subTitle,
        source: this.item.source,
        id: this.item.id ? this.item.id : null,
      };
      // let saveData = JSON.parse(JSON.stringify(this.item));
      item.content = this.$refs.editor.getContent();
      const user = JSON.parse(this.cookies.getCookie("user"));
      item.localUserId = user.id;
      this.$storage.set("autoSaveItem", JSON.stringify(item));
      // saveData.content = this.$refs.editor.getContent();
      // const user = JSON.parse(this.cookies.getCookie("user"));
      // saveData.localUserId = user.id;

      // localStorage.setItem("autoSaveItem", JSON.stringify(this.item));

      //弹出提示框
      this.$notify({
        title: "自动保存成功",
        type: "success",
        duration: 2000,
        // message: '自动保存成功',
        position: "top-right",
      });
    },
    checkLock() {
      contentAPI
        .lock({
          id: this.index_id,
          isLock: 1,
        })
        .then((resp) => {
          // 有其他锁，弹窗
          if (resp.data) {
            Swal.fire({
              icon: "warning",
              html:
                "<h4>当前内容已被" +
                resp.data +
                "锁定，解锁编辑存在覆盖风险！</h4>",
              showCancelButton: true,
              allowEnterKey: false,
              allowOutsideClick: false,
              confirmButtonColor: "#ff0000",
              cancelButtonColor: "#74788d",
              confirmButtonText: "解锁",
              cancelButtonText: "取消",
              customClass: {
                confirmButton: "unlock-confirm-button",
              },
              width: "600px",
            }).then((result) => {
              this.removeAutoSave();
              if (result.isConfirmed) {
                contentAPI
                  .lock({
                    id: this.index_id,
                    isLock: 0,
                  })
                  .then((res) => {
                    contentAPI
                      .lock({
                        id: this.index_id,
                        isLock: 1,
                      })
                      .then((res) => {});
                  });
              } else if (result.isDismissed) {
                this.$router.go(-1);
              }
            });
          }
        });
    },
    viewVideoInfo() {
      let that = this;
      this.articleModal({
        title: that.item.title,
        src: that.item.content,
      });
    },
    toPreview() {
      this.previewUrl = this.item.previewUrl + "&backend=true";
      this.drawer = true;
    },
    openLog() {
      this.show = true;
      this.resId = Number(this.index_id);
    },
    //获取频道列表数据
    getChannelList() {
      let params = {
        page: 1,
        pageSize: 999,
      };
      let that = this;
      let channelList = [];
      $_channel.list(params).then((res) => {
        if (res.code == 0) {
          if (res.data.items) {
            res.data.items.map((val) => {
              channelList.push({
                id: val.id,
                name: val.name,
              });
            });
            that.channelList = channelList;
          }
        }
      });
    },
    getAudio() {
      let text = this.$refs.editor.getText();
      if (text == "" || this.item.content == "") {
        this.info("文章内容不能为空");
        return;
      }
      let params = {
        content: text,
        id: this.index_id,
      };
      article.toAudio(params).then((res) => {
        if (res.code === 0) {
          this.success("音频远端生成中,无需点保存");
          this.audioUrl = "audio";
        } else {
          this.warning(res.msg);
        }
      });
    },
    deleteAudio() {
      this.confirm("确认删除该音频？", () => {
        this.audioUrl = "";
      });
    },
    getInfo() {},
    say() {},
    //获取日志列表数据
    getSyslog() {
      let params = {
        resId: this.index_id,
        page: 1,
        pageSize: 1,
      };
      account.syslog(params).then((resp) => {
        if (resp.data) {
          if (resp.data.items.length) {
            this.syslog = resp.data.items[0];
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code == "media") {
        this.item.userId = obj.item.id;
        this.currentMedia = obj.item;
      }
      if (obj.code == "tab") {
        this.currentTabs = obj.tabs;
        let tabIds = [];
        obj.tabs.forEach(function(item) {
          tabIds.push(item.id);
        });
        this.item.tag = tabIds.toString();
      }
      // if (obj.code == "comment") {
      //   this.currentComments = this.currentComments.concat(obj.item);
      // }
    },

    fetch() {
      this.pageLoading = true;
      var params = {
        id: this.index_id,
      };
      article.detail(params).then((resp) => {
        console.log("文章详情", resp);
        if (resp.code == 0) {
          let editItem = JSON.parse(this.$storage.get("autoSaveItem") || null);
          const user = JSON.parse(this.cookies.getCookie("user"));

          if (editItem && editItem.localUserId != user.id) {
            editItem = "";
          }

          if (editItem) {
            let item = editItem;
            this.detailId = resp.data.id;
            this.autoSaveId = item.id;
            console.log("接口数据", resp.data.id);
            console.log("本地存储数据", item.id);
            if (resp.data.id == item.id) {
              resp.data.title = item.title;
              resp.data.subTitle = item.subTitle;
              resp.data.source = item.source;
              resp.data.content = item.content;
              // let audioUrl = resp.data.audioUrl;
              // //处理标签
              // this.currentTabs = item.currentTabs;
              // resp.data = item;
              // resp.data.audioUrl = audioUrl;
            } else {
              // if (resp.data.tagVOList) {
              //   // this.getTags(); //获取标签列表再根据标签id反查标签数据
              //   let currentTabs = [];
              //   let itemTags = resp.data.tagVOList;
              //   for (var i = 0; i < itemTags.length; i++) {
              //     currentTabs.push({
              //       id: itemTags[i].id,
              //       name: itemTags[i].name,
              //     });
              //   }
              //   this.currentTabs = currentTabs;
              // }
            }
          } else {
            //处理标签
            // if (resp.data.tagVOList) {
            //   // this.getTags(); //获取标签列表再根据标签id反查标签数据
            //   let currentTabs = [];
            //   let itemTags = resp.data.tagVOList;
            //   // console.log(itemTags, "ssssssssss");
            //   // let itemTagsName = this.item.tagName.split(",");
            //   for (var i = 0; i < itemTags.length; i++) {
            //     currentTabs.push({
            //       id: itemTags[i].id,
            //       name: itemTags[i].name,
            //     });
            //   }
            //   this.currentTabs = currentTabs;
            // }
          }
          // let channelIds = [];
          // if (resp.data.channelVOList) {
          //   resp.data.channelVOList.map((val) => {
          //     channelIds.push(val.id);
          //   });
          // }
          // resp.data.channelIds = channelIds;

          this.item = resp.data;
          if (resp.data.audioUrl) {
            this.audioUrl = resp.data.audioUrl;
          }
          // 没有发布时间就获取当前时间
          if (!this.item.publishedAt) {
            this.item.publishedAt = this.utils.getTodayTime();
          }
          if (this.item.userId) {
            this.currentMedia = {
              id: this.item.userId,
              nickname: this.item.username,
            };
          }
          // if (this.item.comments) {
          //   this.currentComments = this.item.comments;
          // }
          // this.item.createTime = this.item.createdAt
          this.item.viewDisabled = parseInt(this.item.viewDisabled);
          this.item.commentDisabled = parseInt(this.item.commentDisabled);
          this.item.shareDisabled = parseInt(this.item.shareDisabled);
          this.item.likeDisabled = parseInt(this.item.likeDisabled);
          this.item.commentImageDisabled = parseInt(
            this.item.commentImageDisabled
          );
          this.item.commentVideoDisabled = parseInt(
            this.item.commentVideoDisabled
          );
          //设置选择了那些
          if (this.item.viewDisabled) {
            this.choiceOperable.push("viewDisabled");
          }
          if (this.item.commentDisabled) {
            this.choiceOperable.push("commentDisabled");
          }
          if (this.item.shareDisabled) {
            this.choiceOperable.push("shareDisabled");
          }
          if (this.item.likeDisabled) {
            this.choiceOperable.push("likeDisabled");
          }
          //评论设置选择了那些
          if (this.item.commentImageDisabled) {
            this.choiceCommentRests.push("commentImageDisabled");
          }
          if (this.item.commentVideoDisabled) {
            this.choiceCommentRests.push("commentVideoDisabled");
          }
          //运营设置选择了那些
          if (this.item.addIndex) {
            this.choiceOperateSet.push("addIndex");
          }
          if (this.item.addRecommend) {
            this.choiceOperateSet.push("addRecommend");
          }
          // if(this.item.addLocal){
          //   this.choiceOperateSet.push('addLocal')
          // }
          if (this.item.image) {
            this.coverImags.push(this.item.image);
          }
          if (this.item.shareImage) {
            this.shareImage = {
              url: this.item.shareImage,
            };
          }
          if (resp.data.tagVOList) {
            // this.getTags(); //获取标签列表再根据标签id反查标签数据
            let currentTabs = [];
            let itemTags = resp.data.tagVOList;
            // console.log(itemTags, "ssssssssss");
            // let itemTagsName = this.item.tagName.split(",");
            for (var i = 0; i < itemTags.length; i++) {
              currentTabs.push({
                id: itemTags[i].id,
                name: itemTags[i].name,
              });
            }
            this.currentTabs = currentTabs;
          }

          this.oldImage = resp.data.image;
          this.oldImageWidth = resp.data.imageWidth;
          this.oldImageHeight = resp.data.imageHeight;
          // if (this.item.tagVOList) {
          //   // this.getTags(); //获取标签列表再根据标签id反查标签数据
          //   let currentTabs = [];
          //   let itemTags = this.item.tagVOList;
          //   // console.log(itemTags, "ssssssssss");
          //   // let itemTagsName = this.item.tagName.split(",");
          //   for (var i = 0; i < itemTags.length; i++) {
          //     currentTabs.push({
          //       id: itemTags[i].id,
          //       name: itemTags[i].name,
          //     });
          //   }
          //   this.currentTabs = currentTabs;
          // }
          // if (this.item.tag) {
          //   // this.getTags() //获取标签列表再根据标签id反查标签数据
          //   let currentTabs = [];
          //   let itemTags = this.item.tag.split(",");
          //   let itemTagsName = this.item.tagName.split(",");
          //   for (var i = 0; i < itemTags.length; i++) {
          //     currentTabs.push({
          //       id: itemTags[i],
          //       name: itemTagsName[i],
          //     });
          //   }
          //   this.currentTabs = currentTabs;
          // }
          this.$refs.titleCheck.checkTitle(resp.data.title);
          this.pageLoading = false;
        }
      });
    },
    getSaveData() {
      let params = JSON.parse(JSON.stringify(this.item));
      params.userId = JSON.parse(localStorage.chosedMedia).id;
      if (this.audioUrl != "audio") {
        params.audioUrl = this.audioUrl;
      }

      if (!params.title) {
        Vue.swal("请输入标题");
        return;
      }
      // if (!params.subTitle) {
      //   Vue.swal("请输入短标题");
      //   return;
      // }
      // if(!params.source){
      //   Vue.swal("请输入来源");
      //   return
      // }
      params.userId = JSON.parse(localStorage.chosedMedia).id;
      // params.userId = this.currentMedia.id;
      // params.username = this.currentMedia.nickname;
      // if (!params.userId) {
      //   Vue.swal("请选择媒体号");
      //   return;
      // }
      if (params.publishedAt) {
        params.publishedAt = params.publishedAt;
      } else {
        Vue.swal("请选择发布日期");
        return;
      }
      params.viewDisabled = "0";
      params.commentDisabled = "0";
      params.shareDisabled = "0";
      params.likeDisabled = "0";
      for (var i = 0; i < this.choiceOperable.length; i++) {
        let key = this.choiceOperable[i];
        if (key == "viewDisabled") {
          params.viewDisabled = "1";
        }
        if (key == "commentDisabled") {
          params.commentDisabled = "1";
        }
        if (key == "shareDisabled") {
          params.shareDisabled = "1";
        }
        if (key == "likeDisabled") {
          params.likeDisabled = "1";
        }
      }
      params.commentImageDisabled = "0";
      params.commentVideoDisabled = "0";
      for (var i = 0; i < this.choiceCommentRests.length; i++) {
        let key = this.choiceCommentRests[i];
        if (key == "commentImageDisabled") {
          params.commentImageDisabled = "1";
        }
        if (key == "commentVideoDisabled") {
          params.commentVideoDisabled = "1";
        }
      }

      // if(!params.tag){
      //   Vue.swal("请选择标签");
      //   return
      // }
      if (this.currentTabs.length) {
        let tagIds = [];
        for (var i = 0; i < this.currentTabs.length; i++) {
          tagIds.push(this.currentTabs[i].id);
        }
        params.tag = tagIds.toString();
      } else {
        delete params.tag;
      }

      params.addIndex = "0";
      params.addRecommend = "0";
      // params.addLocal = '0'
      for (var i = 0; i < this.choiceOperateSet.length; i++) {
        let key = this.choiceOperateSet[i];
        if (key == "addIndex") {
          params.addIndex = "1";
        }
        if (key == "addRecommend") {
          params.addRecommend = "1";
        }
        // if(key == 'addLocal'){
        //   params.addLocal = '1'
        // }
      }
      params.operateViewNum = getOperateNum(params.operateViewNum, "view");
      if (typeof params.operateViewNum == "string") {
        this.warning(params.operateViewNum);
        return;
      }

      params.operateLikeNum = getOperateNum(params.operateLikeNum, "like");
      if (typeof params.operateLikeNum == "string") {
        this.warning(params.operateLikeNum);
        return;
      }
      // params.comments = this.currentComments;
      // if(!params.image){
      //   Vue.swal("请选择封面图片");
      //   return
      // }
      params.content = this.$refs.editor.getContent();
      if (!params.content) {
        Vue.swal("文章详情不能为空");
        return;
      }
      //分享图片
      if (this.shareImage) {
        params.shareImage = this.shareImage.url;
      } else {
        params.shareImage = "";
      }
      console.log("保存参数", params);
      // 1. 编辑信息的时候，保存传参 modifyType=1
      // 2. 编辑详情的时候，保存传参 modifyType=2
      if (this.isModify) {
        params.modifyType = 1;
      } else {
        params.modifyType = 2;
      }
      if (params.channelIds) {
        params.channelIds = params.channelIds.join(",");
      } else {
        params.channelIds = "";
      }
      // params.attachments = this.$refs.attachment.getUrls();
      if (this.index_id) {
        delete params.viewNum;
        delete params.likeNum;
        if (this.oldImage == params.image) {
          params.imageHeight = this.oldImageHeight;
          params.imageWidth = this.oldImageWidth;
        } else {
          params.imageHeight = 0;
          params.imageWidth = 0;
        }
      }
      console.log("保存参数", params);
      return params;
    },

    async submitPreserve(callback) {
      let params = this.getSaveData();
      if (!params) {
        return;
      }
      //检查标题是否重复
      let check = await this.checkContentTitle(params);
      if (!check) {
        return;
      }
      if (this.index_id) {
        console.log(params);
        article.modify(params).then((resp) => {
          if (resp.code == 0) {
            this.addCache("article-edit", {
              id: params.id,
            });
            if (callback) {
              callback();
            } else {
              Vue.swal({
                icon: "success",
                title: "保存成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.removeAutoSave();

              // this.goBack();
            }
          } else {
            Vue.swal(resp.msg);
          }
        });
      } else {
        article.create(params).then((resp) => {
          if (resp.code == 0) {
            this.addCache("article-edit", {
              id: resp.data.id,
            });
            if (callback) {
              // this.index_id = resp.data.id
              this.item.id = resp.data.id;
              callback();
            } else {
              Vue.swal({
                icon: "success",
                title: "创建成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.removeAutoSave();

              this.goBack();
            }
          } else {
            Vue.swal(resp.msg);
          }
        });
      }
    },

    getCovers() {
      let params = {
        htmlStr: this.$refs.editor.getContent(),
      };
      auth.covers(params).then((resp) => {
        if (resp.data) {
          if (resp.data.images) {
            if (resp.data.images.length) {
              this.coverImags = this.coverImags.concat(resp.data.images);
            }
          }
        }
      });
    },

    // removeComment() {
    //   let that = this;
    //   this.selectCurrentItems.forEach(function(item) {
    //     that.currentComments.splice(that.currentComments.indexOf(item), 1);
    //   });
    //   this.selectCurrentItems = [];
    // },

    viewImage(url) {
      window.open(url, "_blank");
    },

    submitReview() {
      let params = this.getSaveData();
      if (!params) {
        return;
      }
      let msg1 = this.index_id ? "保存" : "创建";
      let msg2 = this.verifyFlag == 1 ? "免审发布?" : "提交审核?";
      this.confirm(`确认${msg1}并${msg2}`, this.saveAndDeliver);
    },
    saveAndDeliver() {
      let that = this;
      that.submitPreserve(function() {
        //重新调用一遍详情接口查看有没有敏感词，有就展示出来
        var params = {
          id: that.item.id,
        };
        article.detail(params).then((resp) => {
          if (resp.code == 0) {
            let isWords = false; //有无敏感词
            if (resp.data.words) {
              isWords = true;
            }
            if (resp.data.images) {
              isWords = true;
            }
            if (isWords) {
              // 有敏感词就展示敏感词
              that.contentExamine({
                title: that.verifyFlag == 1 ? "确认免审发布?" : "确认提交审核?",
                cancelText: "取消",
                confirmText: "确定",
                words: resp.data.words,
                images: resp.data.images,
                confirm: () => {
                  that.removeAutoSave();
                  that.contentSubmitExamine();
                },
                cancel: () => {
                  that.toDetail();
                },
              });
            } else {
              that.contentSubmitExamine();
            }
          }
        });
      });
    },
    // 提交审核调用接口
    contentSubmitExamine() {
      let params = {
        ids: [],
      };
      params.ids.push(this.item.id);
      article.examine(params).then((resp) => {
        if (resp.code == 0) {
          Vue.swal({
            icon: "success",
            title: this.verifyFlag == 1 ? "发布成功" : "提交成功",
            showConfirmButton: false,
            timer: 1000,
          });
          this.removeAutoSave();

          this.goBack();
        } else {
          Vue.swal(resp.msg);
        }
      });
    },

    revokeReview() {
      let params = {
        ids: [],
      };
      params.ids.push(this.item.id);
      article.revertExamine(params).then((resp) => {
        if (resp.code == 0) {
          Vue.swal({
            icon: "success",
            title: "撤销成功！",
            showConfirmButton: false,
            timer: 1000,
          });
          this.goBack();
        } else {
          Vue.swal(resp.msg);
        }
      });
    },

    submitPublish() {
      let params = this.getSaveData();
      if (!params) {
        return;
      }
      let that = this;
      that.submitPreserve(function() {
        Swal.fire({
          title: "确定发布?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#f46a6a",
          cancelButtonColor: "#74788d",
          confirmButtonText: "发布",
          cancelButtonText: "取消",
        }).then((result) => {
          if (result.value) {
            let params = {
              ids: [],
            };
            params.ids.push(that.item.id);
            article.publish(params).then((resp) => {
              if (resp.code == 0) {
                Vue.swal({
                  icon: "success",
                  title: "发布成功！",
                  showConfirmButton: false,
                  timer: 1000,
                });
                that.goBack();
              } else {
                Vue.swal(resp.msg);
              }
            });
          }
        });
      });

      // let params = {
      //   ids: []
      // }
      // params.ids.push(this.item.id)
      // article.publish(params).then(resp => {
      //   if (resp.code == 0) {
      //     Vue.swal({
      //       icon: "success",
      //       title: "发布成功！",
      //       showConfirmButton: false,
      //       timer: 1000
      //     });
      //     this.goBack()
      //   } else {
      //     Vue.swal(resp.msg);
      //   }
      // })
    },

    //获取标签列表
    getTags() {
      let params = {
        page: 1,
        pageSize: 999,
        type: 0, // 0内容标签  1用户标签
      };
      let itemTags = this.item.tag.split(",");
      tags.list(params).then((resp) => {
        if (resp.data) {
          if (resp.data.items) {
            let currentTabs = [];
            for (var i = 0; i < itemTags.length; i++) {
              for (var j = 0; j < resp.data.items.length; j++) {
                let item = resp.data.items[j];
                if (itemTags[i] == resp.data.items[j].id) {
                  currentTabs.push(resp.data.items[j]);
                }
              }
            }
            this.currentTabs = currentTabs;
          }
        }
      });
    },

    removeTabs(item) {
      this.currentTabs.splice(this.currentTabs.indexOf(item), 1);
    },

    selectMedia() {
      let userId = this.item.userId ? this.item.userId : "";
      this.$refs.media.showModel(userId);
    },

    selectTag() {
      this.$refs.tag.showModel(this.currentTabs);
    },

    selectComment() {
      this.$refs.comment.showModel();
    },

    uploadSuccess(file) {
      if (file.data) {
        this.coverImags.unshift(file.data);
        this.item.image = file.data;
      }
    },

    removeCover(index) {
      if (!this.isModify) {
        this.coverImags.splice(index, 1);
      }
    },

    goBack() {
      contentAPI
        .lock({
          id: this.index_id,
          isLock: 0,
        })
        .then((res) => {});
      this.$router.go(-1);
    },
    changeCover(url) {
      this.item.image = url;
    },
    //创建提交审核取消时页面变成编辑详情页面
    toDetail() {
      if (!this.$route.query.id) {
        this.coverImags = [];
        this.index_id = this.item.id;
        this.fetch();
        this.$router.replace({
          path: this.$route.path,
          query: {
            id: this.item.id,
          },
        });
      }
    },
    setArticleCover(url) {
      this.item.image = url;
      this.$set(this.coverImags, 0, url);
    },
    setArticleShareCover(url) {
      this.shareImage = {
        url: url,
      };
    },
    //检查标题是否重复
    async checkContentTitle(item) {
      let check = await checkRepeatTitle(item);
      console.log("检查结果", check);
      if (!check) {
        return false;
      } else {
        return true;
      }
    },
    async checkTitle() {
      await waitTime(100);
      if (this.$refs.titleCheck) {
        this.$refs.titleCheck.checkTitle(this.item.title, !this.item.id);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::v-deep .el-tabs__content {
  height: calc(100vh - 175px - 1.25rem - 55px);
  overflow: auto;
}
::v-deep .el-tabs__content::-webkit-scrollbar {
  display: none;
  height: 0;
  width: 0;
}
.submit-bar {
  /* border-top: 0;*/
  margin-top: 0px;
  border-top: 0px solid #ced4da;
  margin-bottom: 1.25rem;
}
.box_wrap {
  /* height: 700px; */
  overflow: auto;
}
.operate-input-item {
  margin-right: 20px;
}

.operate-input-item span {
  padding-right: 5px;
}

.operate-input-item input {
  width: 120px;
  margin-top: -0.55rem;
}

.cover-images .cover-img-item {
  display: flex;
  float: left;
}

.cover-images .cover-img-item .cover-delete {
  font-size: 16px;
  padding-left: 10px;
  cursor: pointer;
}

.cover-images .cover-img-item .cover-image-main {
  /*width: 130px;*/
  text-align: center;
}

.cover-images .cover-img-item .cover-image-main img {
  /*width: 100%;*/
  height: 162px;
  border-radius: 6px;
  display: block;
}

.cover-images .cover-img-item .cover-image-main i {
  padding-top: 10px;
  font-size: 30px;
  cursor: pointer;
}

.select-current-media {
  display: inline-block;
  width: auto;
  padding: 0.47rem 0.75rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  position: relative;
  padding-left: 3.2rem;
}

.select-current-media img {
  width: 1.6rem;
  height: 1.6rem;
  position: absolute;
  left: 0.75rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
